import { render, staticRenderFns } from "./listmarketplace.vue?vue&type=template&id=1bb9f93e&scoped=true&"
import script from "./listmarketplace.vue?vue&type=script&lang=js&"
export * from "./listmarketplace.vue?vue&type=script&lang=js&"
import style0 from "./listmarketplace.vue?vue&type=style&index=0&id=1bb9f93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb9f93e",
  null
  
)

export default component.exports